module.exports = __webpack_public_path__ + "img/admin.c7808a6e.png";